import { fetchFromObject } from 'helpers/object';

export default {
  dataUI: state => field => fetchFromObject(state, field),
  getFieldFromListByValue: (state, getters) => (nameList, value, returnField = 'label') => {
    const list = getters.dataUI(nameList);
    return list.find(element => element.value === value)[returnField];
  },
  hasMasterData: state =>
    !!state.streetType &&
    !!state.documentType &&
    !!state.maritalStatus &&
    !!state.financialIncomes &&
    !!state.profession &&
    !!state.sex &&
    !!state.signType
};
